<template>
    
    <div>

        <div v-if="error" class='alert alert-danger'>
            {{error}}
        </div>

        <div v-if="uiLoaded == false && error == false">
            <loading-full :status='statusmensagem' />
        </div>

        
        <form v-show="uiLoaded" id="payment-form">
            <div id="payment-element">
                <!--Stripe.js injects the Payment Element-->
            </div>
            
            <div id="address-element">
                <!--Stripe.js injects the Payment Element-->
            </div>
            
            <button id="submit">
                <div class="spinner hidden" id="spinner"></div>
                <span id="button-text">Pay now</span>
            </button>
            <div id="payment-message" class="hidden"></div>
        </form>

    </div>   
</template>

<script>

import api from '@/api';
import moment from 'moment';
// var buscaCep = require('busca-cep');
//LETODO - includ installs and check foraccept payment types and compare with paymentOptions

var _SANDBOX = (_ENV == 'development')

import validadeFormMixins from "@/mixins/validateForms"
export default {
    mixins:[validadeFormMixins],

    props:['paymentOption','amount','value'],

    data(){
        return { 
            publishKey:'',
            uiLoaded:false,
            showCardsBands:false,
            currentCreditCardBand:false,
            sessionId:'',
            customAddressBilling:false,
            paymentInfo:{
                cardnumber:'',
                cvv:'',
                duedate:'',
                installments:1,
                billingAddressPostalCode:'',
                billingAddressStreet:'',
                billingAddressDistrict:'',
                billingAddressCity:'',
                billingAddressState:'',
                billingAddressNumber:'',
                creditCardHolderName:'',
                creditCardHolderBirthDate:'',
                creditCardHolderCPF:'',
                creditCardHolderPhone:'',
            },

            creditCardInstallmentsOptions:[], //0: [{installmentAmount: 48.45 interestFree: true, quantity: 1, totalAmount: 48.45},...]
            token:'',
            buyerId:false,
            currentCardType:'',
            scriptLoaded:false,
            error:false,
            acceptCreditCards:[],
            cardBrand:false,
            statusmensagem:'',
        }
    },


    created(){

        if(!window.Stripe){
            this.loadPaymentScript()
        }else{
            this.scriptLoaded = true;
        }
   },

    watch:{
        scriptLoaded:async function(){
            await this.initialize()
        },

        // sessionId:function(val){
        //     PagSeguroDirectPayment.setSessionId(this.sessionId);
        //     this.checkAvaliablePaymentOptions();
        //     this.setBuyerId();
        // },
        
        // buyerId:function(val){
        //     var info = {
        //                 senderHash:this.buyerId,
        //                 }
        //     this.$emit('input', info )
        //     this.$emit('change', info ) 
        // },

        // // cardBrand:function(val){
        // //     this.paymentInfo.brand = val
        // // },

        // token:function(val){

        //     let installments = this.creditCardInstallmentsOptions[ this.paymentInfo.installments - 1 ];
        //     var info = {...this.paymentInfo,
        //                 maxInstallmentNoInterest: this.paymentOption.maxInstallments,
        //                 installmentQuantity: installments.quantity,
        //                 installmentValue: installments.installmentAmount,
        //                 creditCardToken:val,
        //                 senderHash:this.buyerId,
        //                 }
        //     this.$emit('input', info )
        //     this.$emit('change', info )
        // },

        // paymentInfo:function(val, oldval){
        //     if(val.cardnumber != oldval.cardnumber){
        //         this.getCardBrand(val.cardnumber);
        //     }
            
        //     if(val.installments != oldval.installments){
        //         //LETODO - include totalTax getting from installments
        //         // let installments = this.creditCardInstallmentsOptions[ this.paymentInfo.installments - 1 ];
        //     }

        // },

        // cardBrand:function(){
        //     this.getInstallments()
        // },


    },

    computed:{
        // total:function(){
        //     return this.$store.getters['OrderStore'].getTotalFinal
        // },
        paymentType:function(){
            return this.paymentOption.paymentType
        },
        isBoleto:function(){
            return this.paymentOption.paymentType == "boleto"
        },
        isCredit:function(){
            return this.paymentOption.paymentType == "credit"
        },
        paymmentProviderId:function(){
            return this.paymentOption.paymentProviderId
        },
        paymmentProviderName:function(){
            return this.paymentOption.providerId
        },
        paymentProviderUrl:function(){
            return `PaymentProviders/${this.paymmentProviderId}/${this.paymmentProviderName}`
        } ,
        
        creditCardBandImage:function(){
            //   return "https://stc.pagseguro.uol.com.br"+creditCart[this.].images.SMALL.path
        },
        dueDateMonth:function(){
            if( this.paymentInfo.duedate != ''){
                return this.paymentInfo.duedate.match(/^(\d\d\d\d)-(\d\d)/)[2]
            }else{
                return ''
            }
        },
        dueDateYear:function(){
              if( this.paymentInfo.duedate != ''){
                    return this.paymentInfo.duedate.match(/^(\d\d\d\d)-(\d\d)/)[1]
              }else{
                return ''
            }
        },
        installmentOptions:function(){
                // {'name':'Masculino',value:'M'}
            let options = []
            _.each( this.creditCardInstallmentsOptions, v=>{ 
                    
                    let percentual = v.totalAmount/this.amount/v.quantity;
                    let name = `${v.quantity} X R$ ${v.installmentAmount} = ${v.totalAmount}`;
                    if( v.quantity <= this.paymentOption.maxInstallments )
                         options.push({ name, value:v.quantity })
            } )
            return options;
        },
        
        buyerInfo:{
            set:function(val){
                this.$store.commit('OrderStore/updateBuyer', val)
            },
            get:function(val){
                return this.$store.getters['OrderStore/buyer']
            }
        },

    },



    methods:{

        initialize: async function(){
            const publishKey = await this.getPublishKey();
            if(publishKey){
                this.stripe = window.Stripe(publishKey);
            }
            const clientSecret = await this.createPaymentIntent();

            const appearance = {
                theme: 'stripe',
            };
            this.elements = this.stripe.elements({ appearance, clientSecret });

            const paymentElementOptions = {
                layout: "tabs",
            };

            const paymentElement = this.elements.create("payment", paymentElementOptions);
            paymentElement.mount("#payment-element");

            const addressElement = this.elements.create('address', { mode: 'billing' });
            addressElement.mount("#address-element");

            this.uiLoaded = true;

        },


        loadPaymentScript:function(){
            this.error = false;
            this.scriptLoaded = false;
            let pagseguroScript = document.createElement('script')
            pagseguroScript.async = true;
            pagseguroScript.onload = () => {
                this.statusmensagem = ''
                this.scriptLoaded = true;
            }
            pagseguroScript.onerror = () => {
                console.error("Error ao carregar script")
                this.error = "Erro carregando biblioteca de pagamento! Tentando automaticamente em 5 segundos, ou entre em contato com o administrador!";
                setTimeout(this.loadPaymentScript,2000)
           }
            this.statusmensagem = 'carregando informações da meio de pagamento...'
            pagseguroScript.setAttribute('src', 'https://js.stripe.com/v3/')
            document.head.appendChild(pagseguroScript)
        },


        getPublishKey:async function(){
            this.publishKey = false;
            this.error = false;
            this.statusmensagem = 'Pegando informações Adicionais...'
            let res = await api.getJSONAsync(`${this.paymentProviderUrl}/getPublishKey?sandbox=${_SANDBOX}`)
            if(res.error){
                if(res.status = 401){
                    this.error = 'Erro get publish Key - Contacte o Admministrador ';
                }else{
                    this.error = this.message;
                }
                setTimeout(this.startSession,2000)
                return;
            }
            if(res){
                this.statusmensagem = ''
                this.publishKey = res
                return res
            }
        },

    
        createPaymentIntent:async function(){
            this.sessionId = false;
            this.error = false;
            this.statusmensagem = 'gerando session do comprados...'
            let res = await api.getJSONAsync(`${this.paymentProviderUrl}/getPaymentIntent?sandbox=${_SANDBOX}`)
            if(res.error){
                if(res.status = 401){
                    this.error = 'Erro "PaypalSessionDenied" - Contacte o Admministrador ';
                }else{
                    this.error = this.message;
                }
                setTimeout(this.startSession,2000)
                return;
            }
            if(_.has(res,'clientSecret')){
                  this.statusmensagem = ''
                this.sessionId = _.get(res,'clientSecret')
                return this.sessionId
            }
        },
    
    
    
        // startSession:async function(){
        //     this.sessionId = false;
        //     this.error = false;
        //     this.statusmensagem = 'gerando session do comprados...'
        //     let res = await api.getJSONAsync(`${this.paymentProviderUrl}/getSession?sandbox=${_SANDBOX}`)
        //     if(res.error){
        //         if(res.status = 401){
        //             this.error = 'Erro "PaypalSessionDenied" - Contacte o Admministrador ';
        //         }else{
        //             this.error = this.message;
        //         }
        //         setTimeout(this.startSession,2000)
        //         return;
        //     }
        //     if(_.has(res,'session.id')){
        //           this.statusmensagem = ''
        //         this.sessionId = _.get(res,'session.id')
        //     }
        // },

        // validatePagInfo:async function(){

        // },

        // setBuyerId:function(){
        //     this.error = false;
        //     this.statusmensagem = 'gerando identificação unica do comprador'

        //     PagSeguroDirectPayment.onSenderHashReady((response)=>{
                
        //         if( _.get(response,'status') == 'error') {
        //             console.log(response.message);
        //             this.error = response.message;
        //             this.statusmensagem = ""
        //             setTimeout(this.setBuyerId,1000)
        //             return false;
        //         }
        //          var hash = _.get(response,'senderHash')
        //          if(!hash){
        //               this.error = "Erro carregando formulário de pagamento do pagseguro. Tente novamente!"
        //               setTimeout(this.setBuyerId,1000)
        //          }
        //         this.buyerId= response.senderHash; //Hash estará disponível nesta variável.
        //     });
        // },

        // checkAvaliablePaymentOptions:function(){
        
        //     PagSeguroDirectPayment.getPaymentMethods({
        //         amount: parseInt(this.amount,10),
        //         success: (response) => {
        //             //meios de pagamento disponíveis
        //            var credit =  _.get(response, 'paymentMethods.CREDIT_CARD',false)
        //            this.acceptCreditCards = _.get(credit,'options');

        //            //ch eck i paymentoptions is accept by pagseguro
        //         },
        //         error: function(response) {
        //              this.error = response.message;
        //             //tratamento do erro
        //         },
        //         complete: function(response) {
        //             //tratamento comum para todas chamadas
        //         }
        //     });
        // },

      

        // getCardBrand:function(){
        //     return new Promise( (resolve, reject)=>{
        //         PagSeguroDirectPayment.getBrand({
        //             cardBin: parseInt(this.paymentInfo.cardnumber,10),
        //                 success: (response)=> {
                            
        //                     //bandeira encontrada
        //                     this.cardBrand = response.brand;
        //                       resolve(true)
        //                 },
        //                 error: (response)=> {
        //                     //tratamento do erro
        //                             reject(response)
        //                 },
        //                 complete: (response)=> {
        //                     //tratamento comum para todas chamadas
        //                 }
        //         });
        //     })
        // },

        // getInstallments:function(){
            
        //    PagSeguroDirectPayment.getInstallments({	
        //             amount: this.amount,
        //             brand: this.cardBrand.name,
        //             maxInstallmentNoInterest: this.paymentOption.maxInstallments,
        //             success: (response) => {
        //                 //opções de parcelamento disponível
                        
        //                 console.log(response);
        //                 this.creditCardInstallmentsOptions = response.installments[this.cardBrand.name]
        //             },
        //             error: (response) => {
        //                 //tratamento do erro
        //                 this.creditCardInstallmentsOptions = []
        //             },
        //             complete: function(response) {
        //                 //tratamento comum para todas chamadas
        //             }
        //     });
        // },


        // getCardToken:function(){    
        //        return new Promise( (resolve, reject)=>{
        //            var param = {
        //             cardNumber: this.paymentInfo.cardnumber,
        //             brand: this.cardBrand.name,
        //             cvv: this.paymentInfo.cvv,
        //             expirationMonth: this.dueDateMonth,
        //             expirationYear: this.dueDateYear,
        //             success: (response) => {
        //                 //token gerado, esse deve ser usado na chamada da API do Checkout Transparente
        //                 this.token = response.card.token
        //                 resolve(true)
        //             },
        //             error: (response) => {
        //                 //tratamento do erro
        //                 this.token = '';
        //                 console.error(response)
        //                 reject(response)
        //             },
        //             complete: (response) => {
        //                 //tratamento comum para todas chamadas
        //             }
        //             }
        //             PagSeguroDirectPayment.createCardToken(param);
        //         })
        // },

        



        // searchCep:async function(val){
        //         console.log('mudou cep')
            
        //         var cep = val.replace(/\D/g, '');
        //         //Verifica se campo cep possui valor informado.
        //         if (cep != "") {
        //             //Expressão regular para validar o CEP.
        //             var validacep = /^[0-9]{8}$/;
        //             //Valida o formato do CEP.
        //             if(validacep.test(cep)) {
                
        //                 var url = `https://viacep.com.br/ws/${cep}/json`;
                        
        //                 var res = await api.getJSONAsync(url,{},true);
        //                 // .then(res => {
        //                             //"cep": "70855-020", //   "logradouro": "SQN 407 Bloco B", //   "complemento": "", //   "bairro": "Asa Norte", //   "localidade": "Brasília", //   "uf": "DF", //   "unidade": "", //   "ibge": "5300108", //   "gia": "" // }
        //                 if(res.cep){
        //                     this.paymentInfo.billingAddressPostalCode = res.cep;
        //                     this.paymentInfo.billingAddressStreet = res.logradouro;
        //                     this.paymentInfo.billingAddressDistrict = res.bairro;
        //                     this.paymentInfo.billingAddressCity = res.localidade;
        //                     this.paymentInfo.billingAddressState = res.uf;
        //                 }
        //                 // })

        //             }
                
        //         }
               
        // },


        // validate:async function(){

        //     this.error = false;
            
        //     var formValid = await this.validateForms();
        //     if(formValid){
        //         //se credito, vejo se consigo pegar o token
        //         if(this.isCredit){
        //             try{
        //                 if( this.cardBrand == false){
        //                     await this.getCardBrand();
        //                 }
        //                 let res = await this.getCardToken();
        //                 return res;
        //             }catch(e){
        //                 this.error = e.errors;
        //                 return false;
        //             }
        //         }
        //         //se credito, vejo se consigo pegar o token
        //         if(this.isBoleto){
        //             return true;
        //         }


        //     }else{
        //         return false;
        //     }
        
        // }





    }

}
</script>

<style scoped lang="stylus">
    .currentcardband{
        position:absolute;
        right:17px;
        margin-top:-44px;
    }

</style>
